import React from "react";
import { useSelector, useStore } from "react-redux";
import { Descriptions } from "antd";
import { Scrollbars } from "react-custom-scrollbars-2";
import styles from "./index.module.less";

function PortPanel() {
  const { select } = useStore();
  const port = useSelector(select.panel.selectPort);
  if (!port) return null;

  return (
    <div className={`${styles.portPanel} panel-container`}>
      <Scrollbars autoHide autoHideTimeout={1000} autoHideDuration={400}>
        <Descriptions column={1}>
          <Descriptions.Item label="Name">{port.name}</Descriptions.Item>
          <Descriptions.Item label="Code">{port.enName}</Descriptions.Item>
          <Descriptions.Item>{port.description}</Descriptions.Item>
        </Descriptions>
      </Scrollbars>
    </div>
  );
}

export default PortPanel;
